module.exports = __webpack_public_path__ + "img/materia.cff0402b.png";